import { createHttpApi } from './client'
import type { Api } from './types'

/**
 * `VITE_MOCK=1` swaps the server for the in-memory mock.
 *
 * Vite replaces `import.meta.env.VITE_MOCK` with a literal at build time, so
 * in a normal build this is `false`, the branch below is dead code, and the
 * mock and the seed it imports never reach `dist/`.
 */
export const MOCK = import.meta.env.VITE_MOCK === '1'

function lazy(load: () => Promise<Api>): Api {
  let loaded: Promise<Api> | null = null
  const get = () => (loaded ??= load())
  return new Proxy({} as Api, {
    get: (_target, method: keyof Api) =>
      (...args: unknown[]) =>
        get().then((api) => (api[method] as (...a: unknown[]) => Promise<unknown>)(...args)),
  })
}

export const api: Api = MOCK
  ? lazy(() => import('./mock').then(({ createMockApi }) => createMockApi()))
  : createHttpApi()

export { ApiError, SIGN_IN_PATH, reelSource } from './client'
export * from './types'
